import { render, staticRenderFns } from "./Changelogs.vue?vue&type=template&id=bd66fbd6&scoped=true&"
var script = {}
import style0 from "./Changelogs.vue?vue&type=style&index=0&id=bd66fbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd66fbd6",
  null
  
)

export default component.exports